export const InfoContainer = ({ title, value }) => {
    return (
        <div className="cols-span-1 flex flex-col">
            <span className="font-Apparat text-[#42495280] font-[500] md:font-[600] text-[12px] md:text-[16px] leading-[17px] md:leading-[20px]">{title}</span>
            <span className="font-Apparat font-[600] text-[14px] md:text-[20px]   leading-[20px] md:leading-[24px] mt-[4px]">{value}</span>
        </div>
    )
}